import React, { Component } from 'react';
import { Row, Col } from 'antd';
import { pathOr } from 'ramda';

import { TimeRangeField } from 'components/common/fields/DateTimeFields';
import EducationEventDescription from './EducationEventDescription';

export default class EducationEventItem extends Component {
    render() {
        const { event, order, openModalEducationEvent, openModalPerson }  = this.props;
        const eventTime = pathOr({}, ['dt', 'time'], event);

        return (
            <Row className="calendar-row education-event-row">
                <Col className="calendar-number">{order}</Col>
                <Col className="calendar-time">
                    <TimeRangeField time={{ from: eventTime.from, to: eventTime.to }} />
                </Col>
                <Col className="calendar-desc">
                    <EducationEventDescription event={event} openModalEducationEvent={openModalEducationEvent}  />
                </Col>
                { event.people &&
                    <Col className="calendar-name">
                        <a onClick={() => openModalPerson({ id: event.people.id, value: event.people.name})}>
                            {event.people.name}
                        </a>
                    </Col>
                }
            </Row>
        )
    }
}
